import CardCommon from '@op/components/CardCommon';
import React, { useState } from 'react';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import './index.scss';
import { useKeyOpinionsRisingKeyword } from '../../hook';
import { keyOpinionsRisingKeywords } from '@op/components/BubbleCommon/copywritingKey/keyOpinions';
import { useLocation } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { languageSelectOptions } from '@op/components/FilterBoxCommon/constant';
import useLanguage from '@op/hooks/useLanguage';
import { LanguageType } from '@op/types/common';
import { RisingKeywordItem } from '@op/components/Snippets/KeywordItem';

export default function RisingKeywords({ filter }: any) {
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [language, setLanguage] = useState<LanguageType>('origin');

  const pageUrlInfo = useLocation();
  const pageUrlObj = pageUrlInfo?.query || {};

  const { data, loading, keywordClick, formatDate, text } =
    useKeyOpinionsRisingKeyword({
      filter,
      extraData: pageUrlObj,
    });

  return (
    <CardCommon
      className="dbo-rising-keywords"
      title={
        <div className="dbo-rising-keywords-title">
          <span>{formatMessage({ id: 'Rising Keywords' })}</span>
          <BubbleCommon tipsMap={keyOpinionsRisingKeywords} placement={'top'} />
        </div>
      }
      contentCard
      loading={loading}
      empty={data?.list?.length === 0}
      loadingHeight={380}
      emptyHeight={380}
      dropdowns={formatOptionsMessage(languageSelectOptions)}
      dropdownFooter={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
      handleDropdownOnChange={({ value }: { value: any }) => {
        buriedBtnPoint('KONO_Translate', value);
        setLanguage(value);
      }}
    >
      <div className="dbo-rising-keywords-list">
        <div className="dbo-rising-keywords-inner">
          {(data?.list || [])?.map((item, index) => {
            return (
              <RisingKeywordItem
                item={item}
                key={index}
                text={text}
                language={language}
                onClick={() => {
                  keywordClick?.(item);
                  buriedBtnPoint('KONO_ClickKeywords');
                }}
                formatDate={formatDate}
              ></RisingKeywordItem>
            );
          })}
        </div>
      </div>
    </CardCommon>
  );
}
